/**
 * MergeConfirmationDialog Component
 * Dialog for confirming type merge operations with preview
 * Extracted from App.js to reduce main file complexity
 */
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';

const MergeConfirmationDialog = ({
  mergeConfirmation,
  onCancel,
  onConfirm
}) => {
  const isOpen = !!mergeConfirmation;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-amber-600 flex items-center gap-2">
            <AlertTriangle className="w-5 h-5" />
            Confirmar Fusión de Tipos
          </DialogTitle>
          <DialogDescription>
            {mergeConfirmation?.message}
          </DialogDescription>
        </DialogHeader>
        
        {mergeConfirmation?.merge_preview && (
          <div className="space-y-4 py-4">
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
                <p className="font-medium text-blue-800 mb-1">Tipo Existente</p>
                <p className="text-blue-600">
                  {mergeConfirmation.merge_preview.existing_entries_count} muestras
                </p>
                <p className="text-blue-600">
                  Promedio: ${mergeConfirmation.merge_preview.existing_average}/m²
                </p>
              </div>
              <div className="p-3 bg-green-50 rounded-lg border border-green-200">
                <p className="font-medium text-green-800 mb-1">Tipo Actual</p>
                <p className="text-green-600">
                  {mergeConfirmation.merge_preview.current_entries_count} muestras
                </p>
                <p className="text-green-600">
                  Promedio: ${mergeConfirmation.merge_preview.current_average}/m²
                </p>
              </div>
            </div>
            
            <div className="p-3 bg-amber-50 rounded-lg border border-amber-200">
              <p className="font-medium text-amber-800 mb-1">Resultado de la Fusión</p>
              <p className="text-amber-700 font-semibold">
                {mergeConfirmation.merge_preview.projected_entries_count} muestras totales
              </p>
              <p className="text-amber-700 font-semibold">
                Nuevo promedio: ${mergeConfirmation.merge_preview.projected_average}/m²
              </p>
            </div>
            
            <div className="text-xs text-slate-500 bg-slate-100 p-2 rounded">
              <strong>Nota:</strong> Esta operación es irreversible. El tipo actual será 
              eliminado y sus datos se combinarán con el tipo existente.
            </div>
          </div>
        )}
        
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            Cancelar
          </Button>
          <Button 
            onClick={onConfirm}
            className="bg-amber-600 hover:bg-amber-700"
            data-testid="confirm-merge-btn"
          >
            Confirmar Fusión
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default MergeConfirmationDialog;
